import * as React from 'react';
import Box from '@mui/material/Box';
import { columns, generateRows } from './partials';
import { BillingAccountSelector, Table } from '@organisms';
import { useCoreDetailedList, callGetSyncCoreLocations } from '@api';
import { useState, useContext } from 'react';
import { routes, TableContext } from '@particles';
import { Alert, Button, TextView } from '@atoms';
import { DateTime } from 'luxon';
import { Grid, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import { navigate } from '@reach/router';

type CoreAccountsProps = {
  startDate?: Date | null;
  endDate?: Date | null;
};

const CoreAccounts: React.FC<CoreAccountsProps> = (props: CoreAccountsProps) => {
  const {
    state: {
      coreAccountsPagination: { page, perPage, orderBy }
    }
  } = useContext(TableContext);
  const [selectstatus, setSelectStatus] = useState<string>('b');
  const [loadingSyncLocation, setLoadingSyncLocation] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const apiSyncLocations = async () => {
    setLoadingSyncLocation(true);
    const { data, code } = await callGetSyncCoreLocations();
    if (data && code == 200) {
      coreRefetch();
    }
    setLoadingSyncLocation(false);
  };

  const {
    data: coreData,
    error: coreError,
    refetch: coreRefetch,
    isFetching: coreFetching
  } = useCoreDetailedList<Pagination<CoreLocation>>({
    status: selectstatus == 'b' ? undefined : selectstatus,
    pageNumber: page,
    pageSize: perPage,
    sortBy: orderBy,
    startDate: props.startDate
      ? DateTime.fromJSDate(props.startDate).toISO({
        suppressMilliseconds: true,
        includeOffset: false
      })
      : undefined,
    endDate: props.endDate
      ? DateTime.fromJSDate(props.endDate).toISO({
        suppressMilliseconds: true,
        includeOffset: false
      })
      : undefined
  });

  const handleChangestatus = (event: SelectChangeEvent) => {
    setSelectStatus(event.target.value);
  };

  const rowData: TableRow[] =
    coreData && coreData.data && coreData.data.data ? generateRows(coreData.data.data) : [];

  return (
    <Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={6}>
          <BillingAccountSelector
            title="Select Core Account"
            type="c"
            status="both"
            caller="dashboard-core"
            goHref={(core: BillingAccount) => `${routes.SA_Core}/${core.locationId}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} gap={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Select
            value={selectstatus}
            onChange={handleChangestatus}
            displayEmpty
            size="small"
            sx={{ backgroundColor: '#ffffff', fontSize: 14, height: '50' }}
            inputProps={{ 'aria-label': 'Without label' }}>
            <MenuItem key="all" value="b">
              All
            </MenuItem>
            <MenuItem key="live" value="live">
              Live
            </MenuItem>
            <MenuItem key="staging" value="staging">
              Staging
            </MenuItem>
          </Select>
          <Button primary={false} onClick={() => apiSyncLocations()} loading={loadingSyncLocation}>
            <TextView $fontColor="white">Sync Core</TextView>
          </Button>
        </Grid>
      </Grid>
      {error && (
        <Box sx={{ mb: 1 }}>
          <Alert message={error} severity={'error'} />
        </Box>
      )}

      <Table
        title="Core Accounts"
        name="core_accounts"
        columns={columns}
        data={rowData}
        isLoading={coreFetching}
        pagination={coreData?.data}
        persistColumnPrefs
      />
    </Box>
  );
};

export default CoreAccounts;
